export const NEED_PASSWORD = 'The document is password protected';

export const DEFAULT_TOP_OFFSET = 10;
export const DEFAULT_TOP_OFFSET_MOBILE = 68;
export const DEFAULT_BOTTOM_OFFSET = 10;
export const DEFAULT_BOTTOM_OFFSET_MOBILE = 50;
export const DEFAULT_SIDES_OFFSET = 10;
